import { render, staticRenderFns } from "./recap.vue?vue&type=template&id=a5b48e24&scoped=true&"
import script from "./recap.vue?vue&type=script&lang=js&"
export * from "./recap.vue?vue&type=script&lang=js&"
import style0 from "./recap.vue?vue&type=style&index=0&id=a5b48e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b48e24",
  null
  
)

export default component.exports